import { HorseHumanIcon } from './HorseHumanIcon';

/**
 * author: Colton Wiscombe
 * id 784CE1E7-3523-4E04-910C-3E969FEA4E55
 * name horse-human
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/horse-human.svg
 * tags
 * - Transportation + Other 
 * - Agriculture 
 * - People / Family 
 */
export const HorseRidingIcon = HorseHumanIcon;
export default HorseRidingIcon